<template>
    <div>
        <Dj />
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/">
                    home
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center" style="margin-top:20px;">
            <p :style="`font-size:120px; color:${counter_color};`"><b>{{ counter }}</b></p>
        </v-row>
        <v-row class="justify-center" style="margin-top:30px;">
            <p style="font-size:50px;"><b>{{ init_words }}</b></p>
        </v-row>
        <v-row class="justify-center text-center" style="display:none;">
            <v-col cols="10" md="6">
                <audio id="pl" controls autoplay>
                    <source :src="'../audios/'+init_song" type="audio/ogg">
                    Your browser does not support the audio element.
                </audio> 
            </v-col>
        </v-row>
        <v-row class="justify-center" v-if="counter == 0">
            <v-col cols="10" md="6">
                <v-btn block :color="counter_color" dark v-on:click="nuevo">otro minuto</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Dj from './Dj.vue'
import data_ from '../plugins/data.json'


export default {
    name: 'Easy',
    created: function () {
        this.minute()
        this.song()
        this.change()
        this.color()
    },
    components: {
        Dj
    },
    data: () => ({
        counter: 60,
        counter_color:'',
        init_song:'',
        songs_list: data_['songs'],
        init_words:'',
        words_list: data_['words']
    }),
    methods: {
        minute: function(){
            if(this.counter > 0) {
                setTimeout(() => {
                    this.counter -= 1
                    this.minute()
                }, 1000)
            }
        },
        song: function(){
            const random = Math.floor(Math.random() * this.songs_list.length);
            this.init_song = this.songs_list[random]
            this.counter = parseInt(this.counter) -1
        },
        change: function(){
            const random = Math.floor(Math.random() * this.words_list.length);
            this.init_words = this.words_list[random]

            setTimeout(() => {
                this.init_words = this.words_list[random]
                this.change()
            }, 1000*10) // 10 seg
        },
        color: function(){
            const random = Math.floor(Math.random() * data_['colors'].length);
            this.counter_color = data_['colors'][random]
            console.log(this.counter_color)
        },
        nuevo: function(){
            this.counter = 60
            this.songs_list = data_['songs'],
            this.minute()
            //this.song()
            this.change()
            this.color()

            const random = Math.floor(Math.random() * this.songs_list.length);
            const song = this.songs_list[random]

            var p = document.getElementById("pl")
            //pl.currentSrc = song
            p.firstChild.src = song
            p.play()
            console.log('ssss', p)
        }
    },
    watch: {
        counter: function (new_) {
            var pl = document.getElementById("pl")
            if(new_ == 0){
                this.words_list = ''
                this.init_words = ''
                pl.pause()
            }       
        }
    }
}
</script>
